/* ФОПи та рахунки (/finance/fops). Kept apart from uk.ts/en.ts to keep merges small. */
export const fopsUk = {
  'nav.fops': 'ФОПи та рахунки',
  'fops.title': 'ФОПи та рахунки',
  'fops.subtitle': 'ФОПи клініки та грошові рахунки Enote, через які оплати відносяться до ФОП',
  'fops.add': 'Додати ФОП',
  'fops.edit': 'Редагувати ФОП',
  'fops.import': 'Імпорт ФОПів',
  'fops.suggest': 'Запропонувати автоматично',
  'fops.openPage': 'Відкрити «ФОПи та рахунки»',
  'fops.openPageHint': 'ФОПи ведуться в Bridge: в Enote лише одна організація. Оплати відносяться до ФОП через грошовий рахунок.',
  'fops.enoteOrgs': 'Організації Enote',
  'fops.empty': 'ФОПів ще немає',
  'fops.emptyHint': 'Додайте ФОП вручну або імпортуйте таблицю з Google Sheets.',
  'fops.noCity': 'Без міста',
  'fops.accountsN': 'рахунків: {n}',
  'fops.last30': '30 днів: {sum}',
  'fops.archived': 'в архіві',
  'fops.showArchived': 'Показати архівні',
  'fops.kind.fop': 'ФОП',
  'fops.kind.tov': 'ТОВ',
  'fops.kind.other': 'Інше',
  'fops.taxGroup.none': 'Не вказано',
  'fops.taxGroup.n': '{n} гр. ЄП',
  'fops.taxGroup.general': 'Загальна система',
  'fops.f.name': 'Назва',
  'fops.f.nameHint': 'Напр. «ФОП Прізвище»',
  'fops.f.shortName': 'Прізвище для зіставлення',
  'fops.f.shortNameHint': 'Шукається цілим словом у назвах рахунків Enote',
  'fops.f.kind': 'Тип',
  'fops.f.city': 'Місто',
  'fops.f.taxGroup': 'Група ЄП',
  'fops.f.license': 'Ліцензія',
  'fops.f.lease': 'Оренда',
  'fops.f.ipn': 'ІПН / ЄДРПОУ',
  'fops.f.ipnHint': 'Необов’язково; видно лише тим, хто налаштовує фінанси',
  'fops.f.iban': 'Рахунок / IBAN (примітка)',
  'fops.f.notes': 'Нотатки',
  'fops.f.staff': 'Працівники',
  'fops.f.staffHint': 'По одному в рядку',
  'fops.v.shortName': 'Щонайменше 3 літери',
  'fops.v.ipn': '8 або 10 цифр',
  'fops.v.duplicate': 'ФОП з такою назвою вже існує',
  'fops.archive': 'Архівувати',
  'fops.restore': 'Відновити',
  'fops.archiveConfirm': 'Архівувати {name}? Призначені рахунки залишаться, щоб минулі оплати не втратили ФОП.',
  'fops.accounts': 'Грошові рахунки',
  'fops.accountsTotal': 'Рахунків',
  'fops.mapped': 'Призначено',
  'fops.unmappedStat': 'Не визначено',
  'fops.excludedStat': 'Не ФОП',
  'fops.unattributed': 'Без ФОП за 30 днів',
  'fops.group.unmapped': 'Не визначено',
  'fops.group.excluded': 'Не ФОП (сейфи, займи…)',
  'fops.searchAccounts': 'Пошук рахунку',
  'fops.allKinds': 'Усі типи',
  'fops.type.cash': 'Готівка',
  'fops.type.bank': 'Безготівка',
  'fops.type.credit': 'Кредит',
  'fops.fee': 'еквайринг {v}%',
  'fops.mapping': 'Призначення',
  'fops.mapTo': 'ФОП для рахунку {name}',
  'fops.selected': 'Вибрано: {n}',
  'fops.assign': 'Призначити ФОП…',
  'fops.assignApply': 'Призначити',
  'fops.markExcluded': 'Позначити як не ФОП',
  'fops.clearMapping': 'Скинути',
  'fops.clearSelection': 'Зняти вибір',
  'fops.selectGroup': 'Вибрати всі в групі {name}',
  'fops.selectAccount': 'Вибрати {name}',
  'fops.mappedN': 'Оновлено рахунків: {n}',
  'fops.noAccounts': 'Рахунків ще немає — запустіть синхронізацію «Money accounts» у розділі Синхронізація.',
  'fops.s.title': 'Автоматичні пропозиції',
  'fops.s.description': 'Прізвища ФОПів шукаються цілими словами в назвах рахунків. Нічого не зберігається, доки ви не підтвердите.',
  'fops.s.account': 'Рахунок',
  'fops.s.proposal': 'Пропозиція',
  'fops.s.confidence': 'Впевненість',
  'fops.s.reason': 'Чому',
  'fops.s.conf.high': 'висока',
  'fops.s.conf.medium': 'середня',
  'fops.s.conf.low': 'низька',
  'fops.s.chooseManually': 'оберіть вручну',
  'fops.s.applyConfident': 'Застосувати всі впевнені ({n})',
  'fops.s.applySelected': 'Застосувати вибрані ({n})',
  'fops.s.none': 'Пропозицій немає: усі рахунки вже розподілено або назви не містять прізвищ ФОПів.',
  'fops.s.unmatched': 'Без пропозиції: {n}',
  'fops.s.current': 'зараз: {name}',
  'fops.i.title': 'Імпорт ФОПів',
  'fops.i.description': 'Скопіюйте рядки з Google Sheets і вставте сюди. Колонки: Назва, Прізвище, Місто, Група ЄП, Ліцензія, Оренда (і за бажанням Працівники через кому).',
  'fops.i.paste': 'Таблиця (вставте з Google Sheets)',
  'fops.i.preview': 'Попередній перегляд',
  'fops.i.rows': 'Рядків до імпорту: {n}',
  'fops.i.invalid': 'з помилками: {n}',
  'fops.i.run': 'Імпортувати',
  'fops.i.done': 'Створено {created}, оновлено {updated}, без змін {unchanged}, помилок {errors}',
  'fops.i.status.created': 'новий',
  'fops.i.status.updated': 'оновлено',
  'fops.i.status.unchanged': 'без змін',
  'fops.i.status.error': 'помилка',
  'fops.i.nameRequired': 'Немає назви',
  'fops.i.badTaxGroup': 'Незрозуміла група ЄП',
  'fops.i.duplicate': 'Повтор рядка {n}',
  'finance.group.fop': 'ФОП (за рахунком)',
  'finance.notAttributed': 'Не визначено',
  'finance.notFopAccount': 'Не ФОП',
  'finance.enoteOrg': 'Організація Enote',
}

export const fopsEn: { [K in keyof typeof fopsUk]?: string } = {
  'nav.fops': 'Sole proprietors & accounts',
  'fops.title': 'Sole proprietors (ФОП) & accounts',
  'fops.subtitle': 'The clinic’s ФОПи and the Enote money accounts that attribute payments to them',
  'fops.add': 'Add ФОП',
  'fops.edit': 'Edit ФОП',
  'fops.import': 'Import ФОПи',
  'fops.suggest': 'Suggest automatically',
  'fops.openPage': 'Open “ФОПи & accounts”',
  'fops.openPageHint': 'ФОПи are kept in the Bridge: Enote has a single organisation. Payments are attributed to a ФОП through the money account.',
  'fops.enoteOrgs': 'Enote organisations',
  'fops.empty': 'No ФОПи yet',
  'fops.emptyHint': 'Add a ФОП or import the table from Google Sheets.',
  'fops.noCity': 'No city',
  'fops.accountsN': 'accounts: {n}',
  'fops.last30': '30 days: {sum}',
  'fops.archived': 'archived',
  'fops.showArchived': 'Show archived',
  'fops.kind.fop': 'ФОП',
  'fops.kind.tov': 'LLC',
  'fops.kind.other': 'Other',
  'fops.taxGroup.none': 'Not set',
  'fops.taxGroup.n': 'single tax group {n}',
  'fops.taxGroup.general': 'General system',
  'fops.f.name': 'Name',
  'fops.f.nameHint': 'E.g. “ФОП Surname”',
  'fops.f.shortName': 'Surname for matching',
  'fops.f.shortNameHint': 'Matched as a whole word in Enote account names',
  'fops.f.kind': 'Kind',
  'fops.f.city': 'City',
  'fops.f.taxGroup': 'Tax group',
  'fops.f.license': 'Licence',
  'fops.f.lease': 'Lease',
  'fops.f.ipn': 'Tax number',
  'fops.f.ipnHint': 'Optional; visible only to finance configurators',
  'fops.f.iban': 'Bank account / IBAN (note)',
  'fops.f.notes': 'Notes',
  'fops.f.staff': 'Staff',
  'fops.f.staffHint': 'One per line',
  'fops.v.shortName': 'At least 3 letters',
  'fops.v.ipn': '8 or 10 digits',
  'fops.v.duplicate': 'A ФОП with this name already exists',
  'fops.archive': 'Archive',
  'fops.restore': 'Restore',
  'fops.archiveConfirm': 'Archive {name}? Its accounts stay mapped so past payments keep their ФОП.',
  'fops.accounts': 'Money accounts',
  'fops.accountsTotal': 'Accounts',
  'fops.mapped': 'Mapped',
  'fops.unmappedStat': 'Unmapped',
  'fops.excludedStat': 'Not a ФОП',
  'fops.unattributed': 'Unattributed, 30 days',
  'fops.group.unmapped': 'Unmapped',
  'fops.group.excluded': 'Not a ФОП (safes, loans…)',
  'fops.searchAccounts': 'Search accounts',
  'fops.allKinds': 'All types',
  'fops.type.cash': 'Cash',
  'fops.type.bank': 'Bank',
  'fops.type.credit': 'Credit',
  'fops.fee': 'acquiring {v}%',
  'fops.mapping': 'Mapping',
  'fops.mapTo': 'ФОП for account {name}',
  'fops.selected': 'Selected: {n}',
  'fops.assign': 'Assign ФОП…',
  'fops.assignApply': 'Assign',
  'fops.markExcluded': 'Mark as not a ФОП',
  'fops.clearMapping': 'Clear',
  'fops.clearSelection': 'Clear selection',
  'fops.selectGroup': 'Select all in {name}',
  'fops.selectAccount': 'Select {name}',
  'fops.mappedN': 'Accounts updated: {n}',
  'fops.noAccounts': 'No accounts yet — run the “Money accounts” sync in Sync.',
  'fops.s.title': 'Automatic suggestions',
  'fops.s.description': 'ФОП surnames are matched as whole words in account names. Nothing is saved until you confirm.',
  'fops.s.account': 'Account',
  'fops.s.proposal': 'Proposal',
  'fops.s.confidence': 'Confidence',
  'fops.s.reason': 'Reason',
  'fops.s.conf.high': 'high',
  'fops.s.conf.medium': 'medium',
  'fops.s.conf.low': 'low',
  'fops.s.chooseManually': 'choose manually',
  'fops.s.applyConfident': 'Apply all confident ({n})',
  'fops.s.applySelected': 'Apply selected ({n})',
  'fops.s.none': 'No suggestions: all accounts are mapped or no names contain ФОП surnames.',
  'fops.s.unmatched': 'Without a proposal: {n}',
  'fops.s.current': 'now: {name}',
  'fops.i.title': 'Import ФОПи',
  'fops.i.description': 'Copy rows from Google Sheets and paste them here. Columns: Name, Surname, City, Tax group, Licence, Lease (optionally Staff, comma separated).',
  'fops.i.paste': 'Table (paste from Google Sheets)',
  'fops.i.preview': 'Preview',
  'fops.i.rows': 'Rows to import: {n}',
  'fops.i.invalid': 'with errors: {n}',
  'fops.i.run': 'Import',
  'fops.i.done': 'Created {created}, updated {updated}, unchanged {unchanged}, errors {errors}',
  'fops.i.status.created': 'new',
  'fops.i.status.updated': 'updated',
  'fops.i.status.unchanged': 'unchanged',
  'fops.i.status.error': 'error',
  'fops.i.nameRequired': 'Name missing',
  'fops.i.badTaxGroup': 'Unknown tax group',
  'fops.i.duplicate': 'Duplicate of row {n}',
  'finance.group.fop': 'ФОП (by account)',
  'finance.notAttributed': 'Not attributed',
  'finance.notFopAccount': 'Not a ФОП',
  'finance.enoteOrg': 'Enote organisation',
}
